(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bcm-compact-collection-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bcm-compact-collection-bar')) {
    customElements.define('bcm-compact-collection-bar', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        customElements.whenDefined('scroll-carousel').then(() => {
          if (!this.isConnected || signal.aborted) return;
          this.carousel = this.querySelector('scroll-carousel');
          if (!this.carousel) return;
          this.previousButton = this.querySelector('[is="prev-button"]');
          this.nextButton = this.querySelector('[is="next-button"]');
          const update = () => {
            const maximum = this.carousel.scrollWidth - this.carousel.clientWidth;
            const offset = Math.abs(this.carousel.scrollLeft);
            this.toggleAttribute('data-overflow', maximum > 1);
            if (this.previousButton) this.previousButton.disabled = offset <= 1;
            if (this.nextButton) this.nextButton.disabled = offset >= maximum - 1;
          };
          const schedule = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(update);
          };
          this.observer = new ResizeObserver(schedule);
          this.observer.observe(this.carousel);
          this.carousel.addEventListener('scroll', schedule, { passive: true, signal });
          this.addEventListener('control:next', event => this.handleReducedMotion(event, 'next'), { capture: true, signal });
          this.addEventListener('control:prev', event => this.handleReducedMotion(event, 'previous'), { capture: true, signal });
          this.carousel.addEventListener('keydown', event => {
            if (event.altKey || event.ctrlKey || event.metaKey) return;
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const items = this.carousel.items;
            const focused = items.indexOf(document.activeElement);
            const current = focused < 0 ? this.carousel.selectedIndex : focused;
            const forward = getComputedStyle(this.carousel).direction === 'rtl' ? 'ArrowLeft' : 'ArrowRight';
            const index = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : Math.max(0, Math.min(items.length - 1, current + (event.key === forward ? 1 : -1)));
            this.carousel.select(index, { animate: !matchMedia('(prefers-reduced-motion: reduce)').matches });
            items[index]?.focus({ preventScroll: true });
            schedule();
          }, { signal });
          schedule();
        });
      }

      handleReducedMotion(event, action) {
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        event.stopImmediatePropagation();
        this.carousel[action](false);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  if (customElements.get('bcm-gift-picker')) return;
  const marker = 'bcm-cart-gift-v1';
  let busy = false;
  let blocked = false;
  let queued = false;
  let timer;
  let notice = '';
  let latest;
  let pendingMarkup = null;
  const picker = () => document.querySelector('bcm-gift-picker');
  const managed = item => item.marker === marker;
  const free = (item, state) => item.total === 0 && item.discounts.includes(state.discountTitle);
  const permitted = (item, state) => state.gifts.some(g => g.id === item.productId);
  const claimed = state => state.items.find(item => permitted(item, state) && free(item, state));
  const enabled = state => state.enabled && state.collectionSet && state.gifts.length > 0;

  function render(state) {
    const element = picker();
    if (!element || !state) return;
    const box = element.querySelector('[data-gift-content]');
    if (pendingMarkup !== null && !busy) {
      box.innerHTML = pendingMarkup;
      pendingMarkup = null;
    }
    const offered = enabled(state) && state.eligible;
    const chosen = claimed(state);
    element.hidden = !notice && !offered;
    element.setAttribute('aria-busy', String(busy));
    const show = (selector, visible) => {
      const target = box.querySelector(selector);
      if (target) target.hidden = !visible;
    };
    const write = (selector, text) => {
      const target = box.querySelector(selector);
      if (target) target.textContent = text || '';
    };
    write('[data-gift-heading]', chosen ? state.text.added : state.text.heading);
    write('[data-gift-notice]', notice);
    write('[data-gift-selected-title]', chosen?.title);
    show('[data-gift-notice]', Boolean(notice));
    show('[data-gift-working]', busy);
    show('[data-gift-confirmation]', offered && Boolean(chosen));
    show('[data-bcm-gift-remove]', Boolean(chosen && managed(chosen)));
    show('[data-gift-carousel]', offered && !chosen);
    show('[data-gift-navigation]', offered && !chosen);
    show('[data-gift-sold-out]', offered && !chosen);
    box.querySelectorAll('[data-bcm-gift-form] button, [data-bcm-gift-form] select, [data-bcm-gift-remove] button').forEach(control => {
      control.disabled = busy;
    });
  }

  async function request(url, body) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    const options = { credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Cart request failed');
      return data;
    } finally { clearTimeout(timeout); }
  }

  async function readState() {
    const current = picker();
    if (!current) throw new Error('Cart drawer unavailable');
    const url = new URL(location.href);
    url.searchParams.delete('section_id');
    url.searchParams.set('sections', current.dataset.sectionId);
    const sections = await request(url);
    const html = sections[current.dataset.sectionId];
    if (!html) throw new Error('Cart section unavailable');
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const data = doc.querySelector('bcm-gift-picker[data-gift-state]');
    if (!data) throw new Error('Gift settings unavailable');
    pendingMarkup = data.querySelector('[data-gift-content]')?.innerHTML ?? null;
    latest = JSON.parse(data.dataset.giftState);
    return latest;
  }

  function refresh(state) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.querySelectorAll('cart-count').forEach(element => { element.textContent = state.itemCount; });
  }

  async function update(state, changes) {
    await request(`${state.root.replace(/\/?$/, "/")}cart/update.js`, { updates: changes });
    return readState();
  }

  async function clean(state) {
    const changes = {};
    let kept = false;
    for (const item of state.items.filter(managed)) {
      const allowed = enabled(state) && state.eligible && permitted(item, state) && !kept;
      if (!allowed) changes[item.key] = 0;
      else {
        kept = true;
        if (item.quantity !== 1) changes[item.key] = 1;
      }
    }
    let changed = Object.keys(changes).length > 0;
    if (changed) state = await update(state, changes);
    const invalid = state.items.filter(item => managed(item) && !free(item, state));
    if (invalid.length) {
      state = await update(state, Object.fromEntries(invalid.map(item => [item.key, 0])));
      notice = state.text.unavailable;
      changed = true;
    }
    return { state, changed };
  }

  async function run(action, variantId) {
    if (busy) { queued = true; return; }
    busy = true;
    if (action) notice = '';
    render(latest);
    let state = latest;
    let changed = false;
    let attemptedAdd = false;
    try {
      state = await readState();
      const result = await clean(state);
      state = result.state;
      changed = result.changed;
      if (action === 'remove') {
        const own = state.items.filter(managed);
        if (own.length) {
          state = await update(state, Object.fromEntries(own.map(item => [item.key, 0])));
          changed = true;
        }
      } else if (action === 'add') {
        const available = state.gifts.some(gift => gift.variants.some(v => String(v.id) === String(variantId)));
        if (!enabled(state) || !state.eligible || !available) {
          notice = state.text.unavailable;
        } else if (!claimed(state)) {
          attemptedAdd = true;
          await request(`${state.root.replace(/\/?$/, "/")}cart/add.js`, {
            items: [{ id: Number(variantId), quantity: 1, properties: { _bcm_gift: marker } }]
          });
          changed = true;
          state = await readState();
          const added = state.items.find(item => managed(item) && String(item.variantId) === String(variantId));
          if (!added || !free(added, state) || !state.eligible || !enabled(state)) {
            const own = state.items.filter(managed);
            if (own.length) state = await update(state, Object.fromEntries(own.map(item => [item.key, 0])));
            notice = state.text.unavailable;
          }
        }
      }
      blocked = false;
    } catch (error) {
      notice = state?.text.error || latest?.text.error || '';
      blocked = attemptedAdd || Boolean(state?.items.some(managed));
      if (blocked) {
        try {
          state = await readState();
          const own = state.items.filter(managed);
          if (own.length) state = await update(state, Object.fromEntries(own.map(item => [item.key, 0])));
          changed = true;
          blocked = false;
        } catch {
          notice = state?.text.retry || latest?.text.retry || '';
        }
      }
    } finally {
      busy = false;
      latest = state;
      if (changed && state) refresh(state);
      render(state);
      if (queued) { queued = false; schedule(); }
      if (action) requestAnimationFrame(() => picker()?.querySelector('[data-gift-content]')?.focus({ preventScroll: true }));
    }
  }

  function schedule() {
    if (latest && !enabled(latest) && !latest.items.some(managed)) return;
    clearTimeout(timer);
    timer = setTimeout(() => run(), 160);
  }

  customElements.define('bcm-gift-picker', class extends HTMLElement {
    connectedCallback() {
      try {
        const state = JSON.parse(this.dataset.giftState);
        if (!busy) { latest = state; pendingMarkup = null; }
        render(latest || state);
        if (!busy && state.items.some(managed)) schedule();
      } catch { this.hidden = true; }
    }
  });

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const control = target?.closest('bcm-gift-picker [data-bcm-gift-form] button[type="submit"], bcm-gift-picker [data-bcm-gift-remove] button');
    if (control) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      const form = control.closest('[data-bcm-gift-form]');
      run(form ? 'add' : 'remove', form?.elements.namedItem('id')?.value);
      return;
    }
    const checkout = target?.closest('[name="checkout"], a[href*="/checkout"]');
    const quantity = target?.closest('#cart-drawer line-item-quantity, #cart-drawer quantity-selector, #cart-drawer a[href*="/cart/change"]');
    if ((busy || blocked) && (checkout || (busy && quantity))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (blocked && !busy) run();
    }
  }, true);

  document.addEventListener('submit', event => {
    if (event.target.matches('bcm-gift-picker [data-bcm-gift-form]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!busy) run('add', event.target.elements.namedItem('id')?.value);
      return;
    }
    if (!(busy || blocked)) return;
    if (event.submitter?.name === 'checkout' || event.target.action?.includes('/checkout')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (blocked && !busy) run();
    }
  }, true);
  document.addEventListener('cart:change', () => { notice = ''; if (busy) queued = true; else schedule(); });
  window.addEventListener('pageshow', () => { if (latest?.items.some(managed)) schedule(); });
})();


  } catch(e) { console.error(e); }
})();
})();
